// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Work order list + run-sheet selection mode.
   Depends on dashboard-redesign.css for the shell and shared
   .rf-btn / .rf-segmented / .rf-label / .rf-num / .rf-spacer. */

.wo-page {
  flex-grow: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  /* .rf-content is a centring flex row, so a flex item left at the default
     min-width:auto refuses to shrink below its widest child (the filter row
     and the 1040px order sections) and the overflow spills out BOTH sides —
     over the sidebar on the left. Cap the page at its column instead and let
     the strips below scroll or wrap inside it. */
  min-width: 0;
  max-width: 100%;
}

/* ---------------- day rail ----------------
   Full-width strip, selected day at the centre and visually dominant,
   arrows page the strip without changing the selection. */
.wo-dayrail {
  background: #fff;
  border-bottom: 1px solid #e2dcd0;
  padding: 0 16px;
  display: flex;
  align-items: stretch;
  gap: 6px;
  flex-shrink: 0;
}
.wo-rail-arrow {
  align-self: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #e2dcd0;
  background: #fff;
  color: #6f6a60;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 150ms, border-color 150ms;
}
.wo-rail-arrow:hover {
  background: #fdfcfa;
  border-color: #d8cfb8;
  color: #191714;
}
.wo-rail-track {
  flex-grow: 1;
  min-width: 0;
  position: relative;
  overflow: hidden;
}
.wo-rail-strip {
  position: relative;
  display: flex;
  align-items: stretch;
  will-change: left;
}
.wo-day {
  flex: 1 1;
  min-width: 0;
  padding: 10px 4px 8px;
  border: none;
  border-bottom: 2px solid transparent;
  background: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1px;
  font-family: inherit;
  transition: background 150ms;
}
.wo-day:hover {
  background: #fdfcfa;
}
.wo-day.is-active {
  border-bottom-color: var(--rf-brand-lite);
  background: #fdfbf6;
}
.wo-day-dow {
  font-size: 9.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #b5ae9f;
}
.wo-day.is-active .wo-day-dow {
  font-size: 11px;
  color: var(--rf-brand);
}
.wo-day-num {
  font-size: 15px;
  font-weight: 600;
  color: #8b8477;
  line-height: 1.15;
  font-variant-numeric: tabular-nums;
}
.wo-day.is-active .wo-day-num {
  font-size: 28px;
  font-weight: 700;
  color: #191714;
}
.wo-day-sub {
  font-size: 10px;
  color: #c4bdad;
  white-space: nowrap;
  min-height: 12px;
}
.wo-day.is-active .wo-day-sub {
  font-size: 11px;
  font-weight: 600;
  color: var(--rf-brand);
}

/* jump-to-date button + calendar popover at the end of the rail */
.wo-cal-wrap {
  position: relative;
}
.wo-cal-btn.is-open {
  border-color: #d8cfb8;
}
.wo-cal-pop {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 60;
  width: 272px;
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 12px;
  box-shadow: 0 14px 40px rgba(40, 34, 22, 0.16);
  padding: 14px;
}

/* ---------------- run sheet context strip ---------------- */
.wo-runstrip {
  padding: 14px 28px 0;
  display: flex;
  align-items: stretch;
  gap: 12px;
  flex-shrink: 0;
}
.wo-runstrip-existing {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  gap: 10px;
  overflow-x: auto;
}
.wo-runcard {
  flex-shrink: 0;
  min-width: 216px;
  background: #fff;
  border: 1px solid #e2dcd0;
  border-left: 3px solid #4d7a52;
  border-radius: 0;
  padding: 10px 13px;
}
.wo-runcard.is-new {
  min-width: 260px;
}
.wo-runcard-truck {
  font-size: 24px;
  margin-right: 8px;
  vertical-align: -6px;
  flex-shrink: 0;
}
.wo-runcard-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 5px;
}
.wo-runcard-driver {
  font-size: 12.5px;
  font-weight: 600;
  color: #191714;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wo-runcard-vehicle {
  font-size: 11px;
  color: #a29b8d;
  white-space: nowrap;
}
.wo-runcard-area {
  font-size: 11.5px;
  color: #6f6a60;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wo-runcard-foot {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  max-width: 340px;
  margin-top: 7px;
  padding-top: 7px;
  border-top: 1px solid #f0ece3;
}
.wo-runcard-prod {
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  padding: 2px 7px;
  border-radius: 4px;
  white-space: nowrap;
}
.wo-runcard-prod.is-extra {
  background: #fff;
  border: 1px solid;
  border-left-width: 4px;
}
.wo-runcard-window {
  font-size: 11.5px;
  color: #8b8477;
  white-space: nowrap;
}

/* ---------------- filter + actions row ---------------- */
.wo-filters {
  padding: 14px 28px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  /* narrow windows drop the actions onto a second line rather than pushing
     the page wider than its column */
  flex-wrap: wrap;
  row-gap: 8px;
}
.wo-filters .rf-segmented button {
  display: flex;
  align-items: center;
  gap: 7px;
}
.wo-tab-count {
  font-size: 11px;
  color: #a29b8d;
}
.rf-segmented button.is-active .wo-tab-count {
  color: #8b8477;
}
.wo-select {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 34px;
  padding: 0 12px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
  font: 400 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #4a453c;
  cursor: pointer;
  white-space: nowrap;
}
.wo-select:hover {
  border-color: #d8cfb8;
}
.wo-select-k {
  color: #8b8477;
}
.wo-select-v {
  font-weight: 600;
}
/* real <select> inside the styled pill (the prototype used a dummy button) */
.wo-select-native {
  border: none;
  background: transparent;
  font: 600 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #4a453c;
  cursor: pointer;
  outline: none;
  max-width: 150px;
}
.wo-caret {
  color: #a29b8d;
  font-size: 10px;
}
/* keyword search — the topbar field moved down here, where it searches
   work orders (POST /wo/getAllBy/ byQuery) instead of nothing. Base look
   comes from .rf-search in dashboard-redesign.css. */
.wo-search {
  /* shrinks before the row wraps on narrower windows */
  flex: 0 1 210px;
  min-width: 150px;
  background: #fff;
  border-color: #e2dcd0;
}
.wo-search:focus-within {
  border-color: #d8cfb8;
}
/* the browser's own clear button would sit next to ours */
.wo-search input::-webkit-search-cancel-button {
  display: none;
}
.wo-search-clear {
  display: flex;
  align-items: center;
  border: none;
  background: none;
  padding: 0;
  color: #a29b8d;
  font-size: 15px;
  cursor: pointer;
}
.wo-search-clear:hover {
  color: #4a453c;
}
.wo-sortnote {
  font-size: 12.5px;
  color: #8b8477;
  white-space: nowrap;
}
.wo-sortnote b {
  color: #191714;
  font-weight: 600;
}
.wo-filters .rf-btn {
  height: 34px;
}
.wo-btn-cancel {
  padding: 0 13px;
  border: 1px solid #e8c9c3;
  background: #f7ebe9;
  color: #a8483e;
}
.wo-btn-cancel:hover {
  background: #f2ddd9;
}

/* ---------------- order cards ----------------
   Two stacked sections (Funeral Orders, Retail Orders). Each order is a
   headerless card laid out as a grid: identity on the left (two lines),
   a 2×2 block of caption-over-value facts in the middle, and the product
   chips on the right. Quiet typography, hairline dividers, colour only on
   the product chips, the paid/unpaid badges and the legacy swoosh. */
.wo-tablewrap {
  flex-grow: 1;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  padding: 0 28px;
  display: flex;
}
.wo-tbody {
  flex-grow: 1;
  min-width: 0;
  overflow: auto;
  padding: 0 0 60px;
}
.wo-section {
  min-width: 1040px;
}
.wo-section + .wo-section {
  margin-top: 24px;
}
.wo-section-title {
  margin: 0;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 700;
  color: #009688;
  background: #fff;
  box-shadow: 2px 3px 9px rgba(0, 0, 0, 0.18);
  position: relative;
  z-index: 1;
}

.wo-row {
  margin: 10px 0;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 3px 10px rgba(157, 157, 157, 0.25);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: background 200ms, box-shadow 200ms;
}
.wo-row:hover {
  background: #fdfbf6;
  box-shadow: 0 4px 15px rgba(157, 157, 157, 0.45);
}
.wo-row.is-active {
  border-left: 3px solid #f9dfa4;
  margin-left: 16px;
}

/* the swoosh — a full-width background wash behind the content,
   rising from the bottom edge to about 30% of the card height */
.wo-curve {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 30%;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}
.wo-curve svg {
  width: 100%;
  height: 100%;
  display: block;
}

.wo-card {
  position: relative;
  z-index: 1;
  display: grid;
  /* fixed tracks so every card shares the same vertical guides */
  grid-template-columns: minmax(0, 30%) 200px minmax(0, 1fr) minmax(0, 23%);
  grid-auto-rows: minmax(34px, auto);
  align-items: center;
  gap: 0 14px;
  padding: 12px 16px 14px;
}
.wo-ident {
  grid-row: span 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  min-width: 0;
  padding-right: 8px;
}
.wo-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 16px;
  min-width: 0;
}
.wo-col-pick {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 24px;
}
.wo-num {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #f0ece3;
  color: #8b8477;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10.5px;
  font-weight: 700;
}
.wo-name {
  font-size: 15px;
  font-weight: 700;
  color: #191714;
  line-height: 1.3;
  min-width: 0;
}
.wo-done {
  display: inline-flex;
  color: #44bf44;
  font-size: 18px;
  flex-shrink: 0;
}
.wo-pair {
  display: flex;
  gap: 14px;
  min-width: 0;
}
.wo-pair > .wo-fact {
  flex: 1 1;
}

/* facts: thin icon, tiny caption, bold value — no boxes */
.wo-fact {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  min-width: 0;
  padding: 4px 0;
}
.wo-fact-ic {
  display: flex;
  color: var(--rf-brand-soft);
  font-size: 15px;
  flex-shrink: 0;
  margin-top: 1px;
}
.wo-fact-txt {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.2;
}
.wo-fact-k {
  font-size: 9.5px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #a29b8d;
  white-space: nowrap;
}
.wo-fact-v {
  font-size: 12.5px;
  font-weight: 600;
  color: #222;
  display: flex;
  align-items: center;
  gap: 2px;
  overflow-wrap: anywhere;
}
.wo-fact.is-time {
  border-left: 1px solid #efebe3;
  padding-left: 14px;
}
.wo-fact.is-empty .wo-fact-v {
  color: #c4bdad;
}

/* identity line: caption and value inline, dot-separated, no icons */
.wo-ident .wo-fact {
  padding: 0;
}
.wo-ident .wo-fact-ic {
  display: none;
}
.wo-ident .wo-fact-txt {
  flex-direction: row;
  align-items: baseline;
  gap: 5px;
}
.wo-ident .wo-fact-v {
  font-size: 12px;
}

.wo-check {
  width: 18px;
  height: 18px;
  border-radius: 5px;
  border: 1.5px solid #ddd7cb;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  line-height: 1;
}
.wo-check.is-all,
.wo-check.is-some {
  background: var(--rf-brand);
  border-color: var(--rf-brand);
}

/* paid / unpaid badges, colours from the legacy stylesheet */
.wo-label {
  display: inline-block;
  color: #fff;
  font-weight: 700;
  padding: 1px 8px;
  border-radius: 10px;
  margin-left: 5px;
  font-size: 10px;
  line-height: 1.5;
}
.wo-label.is-green {
  background: #44bf44;
}
.wo-label.is-red {
  background: #dc4141;
  margin-left: 0;
}

/* product groups — right column, one per grid row (retail spans both) */
.wo-prodcard {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0 4px 14px;
  border-left: 1px solid #efebe3;
  min-width: 0;
  align-self: stretch;
}
.wo-card.is-retail .wo-prodcard {
  grid-row: span 2;
}
.wo-prodcard-title {
  font-size: 9.5px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #a29b8d;
  white-space: nowrap;
  width: 88px;
  flex-shrink: 0;
}
.wo-prodcard-tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

/* product chips — three selection states */
.wo-prod {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 1px 8px;
  border-radius: 8px;
  background: #c7b691;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}
.wo-prod-mark {
  font-size: 9px;
  opacity: 0.8;
}
/* On a run sheet the chip goes solid with the word on it, so a glance at
   the list says what has been loaded — the old tick / dot was too easy to
   miss. Picked for the run being built: the same green as the "Building
   run sheet" card (NEW_RUN_COLOR). Already on a saved run: that run's
   colour, painted inline to match its card; the red here is only the
   fallback until the runs have loaded. */
.wo-prod.is-on,
.wo-prod.is-taken {
  color: #fff;
  border: 2px solid transparent;
  padding: 0 8px 0 4px;
}
.wo-prod.is-on {
  background: #3f9d4d;
  border-color: #3f9d4d;
  box-shadow: 0 1px 4px rgba(63, 157, 77, 0.35);
}
.wo-prod.is-taken {
  background: #dc4141;
  border-color: #dc4141;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.18);
}
.wo-prod.is-on .wo-prod-mark,
.wo-prod.is-taken .wo-prod-mark {
  opacity: 1;
  font-size: 8.5px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: #fff;
  border-radius: 6px;
  padding: 0 5px;
  line-height: 14px;
}
.wo-prod.is-on .wo-prod-mark {
  color: #2f7a3b;
}
.wo-prod.is-taken .wo-prod-mark {
  color: #b42f2f;
}
/* already on a saved run — its border carries that run's colour so the
   chip still matches the run card on the right */
.wo-prod.is-taken {
  cursor: not-allowed;
}


/* expandable funeral groups (several work orders on one funeral) */
.wo-cardwrap {
  position: relative;
  overflow: hidden;
}
.wo-more {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 11px;
  font-weight: 600;
  color: var(--rf-brand);
  background: var(--rf-brand-tint);
  border-radius: 10px;
  padding: 1px 6px 1px 9px;
  white-space: nowrap;
}
.wo-more svg {
  font-size: 15px;
  transition: transform 150ms;
}
.wo-more.is-open svg {
  transform: rotate(180deg);
}
.wo-subs {
  border-top: 1px solid #f4e3bf;
  background: #fdfbf6;
}
.wo-sub {
  display: grid;
  grid-template-columns: minmax(0, 30%) 200px minmax(0, 1fr) minmax(0, 23%);
  gap: 0 14px;
  align-items: center;
  padding: 6px 16px 6px 13px;
  border-left: 3px solid #f4e3bf;
  cursor: pointer;
}
.wo-sub + .wo-sub {
  border-top: 1px solid #f0ece3;
}
.wo-sub:hover {
  background: #fbf6ea;
}
.wo-sub.is-active {
  border-left-color: #c7b691;
}
.wo-sub-ident {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 16px;
  min-width: 0;
}
.wo-sub-num {
  flex-shrink: 0;
  font-size: 10.5px;
  font-weight: 700;
  color: #a29b8d;
  min-width: 26px;
}
.wo-sub-ident .wo-fact {
  padding: 0;
}
.wo-sub-ident .wo-fact-txt {
  flex-direction: row;
  align-items: baseline;
  gap: 5px;
}
.wo-sub-ident .wo-fact-v {
  font-size: 12px;
}
.wo-sub-gap {
  grid-column: span 2;
}
.wo-sub-prods {
  display: flex;
  flex-direction: column;
  align-self: stretch;
}
.wo-sub-prods .wo-prodcard {
  min-height: 26px;
  padding-top: 2px;
  padding-bottom: 2px;
}

/* ---------------- selection bar ---------------- */
.wo-selectbar {
  flex-shrink: 0;
  background: #fff;
  border-top: 1px solid #e2dcd0;
  padding: 12px 28px;
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  row-gap: 10px;
  box-shadow: 0 -6px 18px rgba(40, 34, 22, 0.06);
}
.wo-selectbar-count {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #17150f;
  color: var(--rf-brand-bright);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}
.wo-selectbar-title {
  font-size: 13px;
  font-weight: 600;
  color: #191714;
}
.wo-selectbar-note {
  font-size: 11.5px;
  color: #8b8477;
}
.wo-selectbar .rf-btn {
  height: 36px;
  border-radius: 9px;
}
.wo-build {
  display: flex;
  align-items: center;
  gap: 8px;
}
.wo-build:disabled {
  opacity: 0.5;
  cursor: default;
}
.wo-build-hint {
  font-size: 11px;
  opacity: 0.75;
  font-weight: 400;
}
.wo-pagepad {
  height: 24px;
  flex-shrink: 0;
}

/* ---------------- responsive: tablet ---------------- */
@media (max-width: 1200px) {
  .wo-runcard.is-new {
    min-width: 220px;
  }
}
@media (max-width: 1000px) {
  /* claw back the 28px gutters so the order cards get the width instead */
  .wo-filters,
  .wo-selectbar {
    padding-left: 16px;
    padding-right: 16px;
  }
  .wo-runstrip {
    padding-left: 16px;
    padding-right: 16px;
  }
  .wo-tablewrap {
    padding: 0 16px;
  }
}

/* Order that came across from another business — its serial keeps that
   business's prefix, so the row says where it came from. */
.wo-from {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 10px;
  background: #f3ece0;
  border: 1px solid #e4d8c2;
  color: var(--rf-brand-deep);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
  flex-shrink: 0;
}

/* ================= run mode: the type bubble ================= */
/* The legacy list asked "Casket Cover or Tribute?" in a gold-capped bubble
   with a tip on the row it came from — kept, on the brand tokens so it
   follows each business's colour. */
.wo-prompt-scrim {
  position: fixed;
  inset: 0;
  z-index: 90;
}
.wo-prompt {
  position: fixed;
  z-index: 91;
  width: 300px;
  background: #fff;
  border-radius: 7px;
  box-shadow: 0 16px 40px rgba(40, 34, 22, 0.26);
}
.wo-prompt-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 12px;
  background: var(--rf-brand-lite);
  color: #fff;
  border-radius: 7px 7px 0 0;
  position: relative;
  z-index: 2;
}
.wo-prompt-head span {
  flex-grow: 1;
  text-align: center;
  /* optical centring: the close button sits in the right-hand gutter */
  padding-left: 26px;
  font-size: 15.5px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wo-prompt-x {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #fff;
  font-size: 21px;
  line-height: 0;
  opacity: 0.85;
  cursor: pointer;
  flex-shrink: 0;
}
.wo-prompt-x:hover {
  opacity: 1;
}
.wo-prompt-opts {
  display: flex;
  position: relative;
  z-index: 2;
}
.wo-prompt-opts button {
  width: 50%;
  padding: 12px 10px;
  border: none;
  background: #fff;
  font: 500 15px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
  cursor: pointer;
}
.wo-prompt-opts button:first-child {
  border-radius: 0 0 0 7px;
}
.wo-prompt-opts button:last-child {
  border-radius: 0 0 7px 0;
  border-left: 1px solid #efe9dd;
}
.wo-prompt-opts button:hover {
  background: var(--rf-brand-lite);
  color: #fff;
}
/* the tip: a square turned on its corner, tucked behind the bubble so
   only the half pointing at the row shows */
.wo-prompt-tip {
  position: absolute;
  left: 50%;
  bottom: -9px;
  z-index: 0;
  width: 18px;
  height: 18px;
  margin-left: -9px;
  background: var(--rf-brand-lite);
  transform: rotate(45deg);
}
.wo-prompt.is-below .wo-prompt-tip {
  bottom: auto;
  top: -9px;
}

/* ================= run mode: the "can't add that" notice ================= */
.wo-alert-wrap {
  position: fixed;
  inset: 0;
  z-index: 95;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.wo-alert-scrim {
  position: absolute;
  inset: 0;
  background: rgba(25, 23, 20, 0.34);
}
.wo-alert {
  position: relative;
  width: 380px;
  max-width: 100%;
  background: #fff;
  border: 1px solid #ddd7cb;
  border-radius: 14px;
  box-shadow: 0 30px 80px rgba(40, 34, 22, 0.3);
  padding: 20px 22px 18px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
.wo-alert-title {
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 21px;
  color: #191714;
}
.wo-alert-msg {
  font-size: 13.5px;
  line-height: 1.5;
  color: #4a453c;
  text-wrap: pretty;
}
.wo-alert .rf-btn {
  align-self: flex-end;
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/work-order-list.css"],"names":[],"mappings":"AAAA;;gEAEgE;;AAEhE;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB;;;;iDAI+C;EAC/C,YAAY;EACZ,eAAe;AACjB;;AAEA;;0DAE0D;AAC1D;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gDAAgD;AAClD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,SAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;AACf;;AAEA,8DAA8D;AAC9D;EACE,oBAAoB;EACpB,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd;qCACmC;EACnC,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,8DAA8D;EAC9D,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA,6EAA6E;AAC7E;EACE,YAAY;EACZ,uBAAuB;EACvB,8DAA8D;EAC9D,cAAc;EACd,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;;qDAEqD;AACrD;EACE,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA,0DAA0D;AAC1D;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA;;;;;qEAKqE;AACrE;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;EAChD,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,gDAAgD;AAClD;AACA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;gEACgE;AAChE;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,+DAA+D;EAC/D,yEAAyE;EACzE,kCAAkC;EAClC,mBAAmB;EACnB,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,YAAY;AACd;AACA;EACE,SAAW;AACb;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA,qEAAqE;AACrE;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;AACA;;EAEE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,6DAA6D;AAC7D;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA,2CAA2C;AAC3C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;;;;;yCAKyC;AACzC;;EAEE,WAAW;EACX,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;AACA;;EAEE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;iDACiD;AACjD;EACE,mBAAmB;AACrB;;;AAGA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yEAAyE;EACzE,WAAW;EACX,mBAAmB;EACnB,0BAA0B;EAC1B,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,YAAY;AACd;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,aAAa;EACb,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA,yDAAyD;AACzD;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,wEAAwE;EACxE;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;2DAC2D;AAC3D;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,kEAAkE;AAClE;;oCAEoC;AACpC;EACE,eAAe;EACf,QAAQ;EACR,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,qEAAqE;EACrE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,cAAc;EACd,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,8DAA8D;EAC9D,cAAc;EACd,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;AACA;EACE,gCAAgC;EAChC,WAAW;AACb;AACA;4CAC4C;AAC5C;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA,8EAA8E;AAC9E;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,+CAA+C;EAC/C,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB","sourcesContent":["/* Work order list + run-sheet selection mode.\n   Depends on dashboard-redesign.css for the shell and shared\n   .rf-btn / .rf-segmented / .rf-label / .rf-num / .rf-spacer. */\n\n.wo-page {\n  flex-grow: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  /* .rf-content is a centring flex row, so a flex item left at the default\n     min-width:auto refuses to shrink below its widest child (the filter row\n     and the 1040px order sections) and the overflow spills out BOTH sides —\n     over the sidebar on the left. Cap the page at its column instead and let\n     the strips below scroll or wrap inside it. */\n  min-width: 0;\n  max-width: 100%;\n}\n\n/* ---------------- day rail ----------------\n   Full-width strip, selected day at the centre and visually dominant,\n   arrows page the strip without changing the selection. */\n.wo-dayrail {\n  background: #fff;\n  border-bottom: 1px solid #e2dcd0;\n  padding: 0 16px;\n  display: flex;\n  align-items: stretch;\n  gap: 6px;\n  flex-shrink: 0;\n}\n.wo-rail-arrow {\n  align-self: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: 1px solid #e2dcd0;\n  background: #fff;\n  color: #6f6a60;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 150ms, border-color 150ms;\n}\n.wo-rail-arrow:hover {\n  background: #fdfcfa;\n  border-color: #d8cfb8;\n  color: #191714;\n}\n.wo-rail-track {\n  flex-grow: 1;\n  min-width: 0;\n  position: relative;\n  overflow: hidden;\n}\n.wo-rail-strip {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  will-change: left;\n}\n.wo-day {\n  flex: 1 1 0;\n  min-width: 0;\n  padding: 10px 4px 8px;\n  border: none;\n  border-bottom: 2px solid transparent;\n  background: none;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1px;\n  font-family: inherit;\n  transition: background 150ms;\n}\n.wo-day:hover {\n  background: #fdfcfa;\n}\n.wo-day.is-active {\n  border-bottom-color: var(--rf-brand-lite);\n  background: #fdfbf6;\n}\n.wo-day-dow {\n  font-size: 9.5px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #b5ae9f;\n}\n.wo-day.is-active .wo-day-dow {\n  font-size: 11px;\n  color: var(--rf-brand);\n}\n.wo-day-num {\n  font-size: 15px;\n  font-weight: 600;\n  color: #8b8477;\n  line-height: 1.15;\n  font-variant-numeric: tabular-nums;\n}\n.wo-day.is-active .wo-day-num {\n  font-size: 28px;\n  font-weight: 700;\n  color: #191714;\n}\n.wo-day-sub {\n  font-size: 10px;\n  color: #c4bdad;\n  white-space: nowrap;\n  min-height: 12px;\n}\n.wo-day.is-active .wo-day-sub {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--rf-brand);\n}\n\n/* jump-to-date button + calendar popover at the end of the rail */\n.wo-cal-wrap {\n  position: relative;\n}\n.wo-cal-btn.is-open {\n  border-color: #d8cfb8;\n}\n.wo-cal-pop {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  z-index: 60;\n  width: 272px;\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 12px;\n  box-shadow: 0 14px 40px rgba(40, 34, 22, 0.16);\n  padding: 14px;\n}\n\n/* ---------------- run sheet context strip ---------------- */\n.wo-runstrip {\n  padding: 14px 28px 0;\n  display: flex;\n  align-items: stretch;\n  gap: 12px;\n  flex-shrink: 0;\n}\n.wo-runstrip-existing {\n  flex-grow: 1;\n  min-width: 0;\n  display: flex;\n  gap: 10px;\n  overflow-x: auto;\n}\n.wo-runcard {\n  flex-shrink: 0;\n  min-width: 216px;\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-left: 3px solid #4d7a52;\n  border-radius: 0;\n  padding: 10px 13px;\n}\n.wo-runcard.is-new {\n  min-width: 260px;\n}\n.wo-runcard-truck {\n  font-size: 24px;\n  margin-right: 8px;\n  vertical-align: -6px;\n  flex-shrink: 0;\n}\n.wo-runcard-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 5px;\n}\n.wo-runcard-driver {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #191714;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.wo-runcard-vehicle {\n  font-size: 11px;\n  color: #a29b8d;\n  white-space: nowrap;\n}\n.wo-runcard-area {\n  font-size: 11.5px;\n  color: #6f6a60;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.wo-runcard-foot {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n  max-width: 340px;\n  margin-top: 7px;\n  padding-top: 7px;\n  border-top: 1px solid #f0ece3;\n}\n.wo-runcard-prod {\n  font-size: 11px;\n  font-weight: 600;\n  color: #fff;\n  padding: 2px 7px;\n  border-radius: 4px;\n  white-space: nowrap;\n}\n.wo-runcard-prod.is-extra {\n  background: #fff;\n  border: 1px solid;\n  border-left-width: 4px;\n}\n.wo-runcard-window {\n  font-size: 11.5px;\n  color: #8b8477;\n  white-space: nowrap;\n}\n\n/* ---------------- filter + actions row ---------------- */\n.wo-filters {\n  padding: 14px 28px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  /* narrow windows drop the actions onto a second line rather than pushing\n     the page wider than its column */\n  flex-wrap: wrap;\n  row-gap: 8px;\n}\n.wo-filters .rf-segmented button {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n.wo-tab-count {\n  font-size: 11px;\n  color: #a29b8d;\n}\n.rf-segmented button.is-active .wo-tab-count {\n  color: #8b8477;\n}\n.wo-select {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 34px;\n  padding: 0 12px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n  font: 400 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #4a453c;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.wo-select:hover {\n  border-color: #d8cfb8;\n}\n.wo-select-k {\n  color: #8b8477;\n}\n.wo-select-v {\n  font-weight: 600;\n}\n/* real <select> inside the styled pill (the prototype used a dummy button) */\n.wo-select-native {\n  border: none;\n  background: transparent;\n  font: 600 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #4a453c;\n  cursor: pointer;\n  outline: none;\n  max-width: 150px;\n}\n.wo-caret {\n  color: #a29b8d;\n  font-size: 10px;\n}\n/* keyword search — the topbar field moved down here, where it searches\n   work orders (POST /wo/getAllBy/ byQuery) instead of nothing. Base look\n   comes from .rf-search in dashboard-redesign.css. */\n.wo-search {\n  /* shrinks before the row wraps on narrower windows */\n  flex: 0 1 210px;\n  min-width: 150px;\n  background: #fff;\n  border-color: #e2dcd0;\n}\n.wo-search:focus-within {\n  border-color: #d8cfb8;\n}\n/* the browser's own clear button would sit next to ours */\n.wo-search input::-webkit-search-cancel-button {\n  display: none;\n}\n.wo-search-clear {\n  display: flex;\n  align-items: center;\n  border: none;\n  background: none;\n  padding: 0;\n  color: #a29b8d;\n  font-size: 15px;\n  cursor: pointer;\n}\n.wo-search-clear:hover {\n  color: #4a453c;\n}\n.wo-sortnote {\n  font-size: 12.5px;\n  color: #8b8477;\n  white-space: nowrap;\n}\n.wo-sortnote b {\n  color: #191714;\n  font-weight: 600;\n}\n.wo-filters .rf-btn {\n  height: 34px;\n}\n.wo-btn-cancel {\n  padding: 0 13px;\n  border: 1px solid #e8c9c3;\n  background: #f7ebe9;\n  color: #a8483e;\n}\n.wo-btn-cancel:hover {\n  background: #f2ddd9;\n}\n\n/* ---------------- order cards ----------------\n   Two stacked sections (Funeral Orders, Retail Orders). Each order is a\n   headerless card laid out as a grid: identity on the left (two lines),\n   a 2×2 block of caption-over-value facts in the middle, and the product\n   chips on the right. Quiet typography, hairline dividers, colour only on\n   the product chips, the paid/unpaid badges and the legacy swoosh. */\n.wo-tablewrap {\n  flex-grow: 1;\n  min-height: 0;\n  min-width: 0;\n  overflow: hidden;\n  padding: 0 28px;\n  display: flex;\n}\n.wo-tbody {\n  flex-grow: 1;\n  min-width: 0;\n  overflow: auto;\n  padding: 0 0 60px;\n}\n.wo-section {\n  min-width: 1040px;\n}\n.wo-section + .wo-section {\n  margin-top: 24px;\n}\n.wo-section-title {\n  margin: 0;\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #009688;\n  background: #fff;\n  box-shadow: 2px 3px 9px rgba(0, 0, 0, 0.18);\n  position: relative;\n  z-index: 1;\n}\n\n.wo-row {\n  margin: 10px 0;\n  background: #fff;\n  border-radius: 6px;\n  box-shadow: 0 3px 10px rgba(157, 157, 157, 0.25);\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  transition: background 200ms, box-shadow 200ms;\n}\n.wo-row:hover {\n  background: #fdfbf6;\n  box-shadow: 0 4px 15px rgba(157, 157, 157, 0.45);\n}\n.wo-row.is-active {\n  border-left: 3px solid #f9dfa4;\n  margin-left: 16px;\n}\n\n/* the swoosh — a full-width background wash behind the content,\n   rising from the bottom edge to about 30% of the card height */\n.wo-curve {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 30%;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: 0;\n}\n.wo-curve svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.wo-card {\n  position: relative;\n  z-index: 1;\n  display: grid;\n  /* fixed tracks so every card shares the same vertical guides */\n  grid-template-columns: minmax(0, 30%) 200px minmax(0, 1fr) minmax(0, 23%);\n  grid-auto-rows: minmax(34px, auto);\n  align-items: center;\n  gap: 0 14px;\n  padding: 12px 16px 14px;\n}\n.wo-ident {\n  grid-row: span 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 6px;\n  min-width: 0;\n  padding-right: 8px;\n}\n.wo-line {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px 16px;\n  min-width: 0;\n}\n.wo-col-pick {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 24px;\n}\n.wo-num {\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #f0ece3;\n  color: #8b8477;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10.5px;\n  font-weight: 700;\n}\n.wo-name {\n  font-size: 15px;\n  font-weight: 700;\n  color: #191714;\n  line-height: 1.3;\n  min-width: 0;\n}\n.wo-done {\n  display: inline-flex;\n  color: #44bf44;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n.wo-pair {\n  display: flex;\n  gap: 14px;\n  min-width: 0;\n}\n.wo-pair > .wo-fact {\n  flex: 1 1 0;\n}\n\n/* facts: thin icon, tiny caption, bold value — no boxes */\n.wo-fact {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  min-width: 0;\n  padding: 4px 0;\n}\n.wo-fact-ic {\n  display: flex;\n  color: var(--rf-brand-soft);\n  font-size: 15px;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n.wo-fact-txt {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  line-height: 1.2;\n}\n.wo-fact-k {\n  font-size: 9.5px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #a29b8d;\n  white-space: nowrap;\n}\n.wo-fact-v {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #222;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  overflow-wrap: anywhere;\n}\n.wo-fact.is-time {\n  border-left: 1px solid #efebe3;\n  padding-left: 14px;\n}\n.wo-fact.is-empty .wo-fact-v {\n  color: #c4bdad;\n}\n\n/* identity line: caption and value inline, dot-separated, no icons */\n.wo-ident .wo-fact {\n  padding: 0;\n}\n.wo-ident .wo-fact-ic {\n  display: none;\n}\n.wo-ident .wo-fact-txt {\n  flex-direction: row;\n  align-items: baseline;\n  gap: 5px;\n}\n.wo-ident .wo-fact-v {\n  font-size: 12px;\n}\n\n.wo-check {\n  width: 18px;\n  height: 18px;\n  border-radius: 5px;\n  border: 1.5px solid #ddd7cb;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  color: #fff;\n  line-height: 1;\n}\n.wo-check.is-all,\n.wo-check.is-some {\n  background: var(--rf-brand);\n  border-color: var(--rf-brand);\n}\n\n/* paid / unpaid badges, colours from the legacy stylesheet */\n.wo-label {\n  display: inline-block;\n  color: #fff;\n  font-weight: 700;\n  padding: 1px 8px;\n  border-radius: 10px;\n  margin-left: 5px;\n  font-size: 10px;\n  line-height: 1.5;\n}\n.wo-label.is-green {\n  background: #44bf44;\n}\n.wo-label.is-red {\n  background: #dc4141;\n  margin-left: 0;\n}\n\n/* product groups — right column, one per grid row (retail spans both) */\n.wo-prodcard {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 0 4px 14px;\n  border-left: 1px solid #efebe3;\n  min-width: 0;\n  align-self: stretch;\n}\n.wo-card.is-retail .wo-prodcard {\n  grid-row: span 2;\n}\n.wo-prodcard-title {\n  font-size: 9.5px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #a29b8d;\n  white-space: nowrap;\n  width: 88px;\n  flex-shrink: 0;\n}\n.wo-prodcard-tags {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n/* product chips — three selection states */\n.wo-prod {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 1px 8px;\n  border-radius: 8px;\n  background: #c7b691;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.wo-prod-mark {\n  font-size: 9px;\n  opacity: 0.8;\n}\n/* On a run sheet the chip goes solid with the word on it, so a glance at\n   the list says what has been loaded — the old tick / dot was too easy to\n   miss. Picked for the run being built: the same green as the \"Building\n   run sheet\" card (NEW_RUN_COLOR). Already on a saved run: that run's\n   colour, painted inline to match its card; the red here is only the\n   fallback until the runs have loaded. */\n.wo-prod.is-on,\n.wo-prod.is-taken {\n  color: #fff;\n  border: 2px solid transparent;\n  padding: 0 8px 0 4px;\n}\n.wo-prod.is-on {\n  background: #3f9d4d;\n  border-color: #3f9d4d;\n  box-shadow: 0 1px 4px rgba(63, 157, 77, 0.35);\n}\n.wo-prod.is-taken {\n  background: #dc4141;\n  border-color: #dc4141;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.18);\n}\n.wo-prod.is-on .wo-prod-mark,\n.wo-prod.is-taken .wo-prod-mark {\n  opacity: 1;\n  font-size: 8.5px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  background: #fff;\n  border-radius: 6px;\n  padding: 0 5px;\n  line-height: 14px;\n}\n.wo-prod.is-on .wo-prod-mark {\n  color: #2f7a3b;\n}\n.wo-prod.is-taken .wo-prod-mark {\n  color: #b42f2f;\n}\n/* already on a saved run — its border carries that run's colour so the\n   chip still matches the run card on the right */\n.wo-prod.is-taken {\n  cursor: not-allowed;\n}\n\n\n/* expandable funeral groups (several work orders on one funeral) */\n.wo-cardwrap {\n  position: relative;\n  overflow: hidden;\n}\n.wo-more {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--rf-brand);\n  background: var(--rf-brand-tint);\n  border-radius: 10px;\n  padding: 1px 6px 1px 9px;\n  white-space: nowrap;\n}\n.wo-more svg {\n  font-size: 15px;\n  transition: transform 150ms;\n}\n.wo-more.is-open svg {\n  transform: rotate(180deg);\n}\n.wo-subs {\n  border-top: 1px solid #f4e3bf;\n  background: #fdfbf6;\n}\n.wo-sub {\n  display: grid;\n  grid-template-columns: minmax(0, 30%) 200px minmax(0, 1fr) minmax(0, 23%);\n  gap: 0 14px;\n  align-items: center;\n  padding: 6px 16px 6px 13px;\n  border-left: 3px solid #f4e3bf;\n  cursor: pointer;\n}\n.wo-sub + .wo-sub {\n  border-top: 1px solid #f0ece3;\n}\n.wo-sub:hover {\n  background: #fbf6ea;\n}\n.wo-sub.is-active {\n  border-left-color: #c7b691;\n}\n.wo-sub-ident {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px 16px;\n  min-width: 0;\n}\n.wo-sub-num {\n  flex-shrink: 0;\n  font-size: 10.5px;\n  font-weight: 700;\n  color: #a29b8d;\n  min-width: 26px;\n}\n.wo-sub-ident .wo-fact {\n  padding: 0;\n}\n.wo-sub-ident .wo-fact-txt {\n  flex-direction: row;\n  align-items: baseline;\n  gap: 5px;\n}\n.wo-sub-ident .wo-fact-v {\n  font-size: 12px;\n}\n.wo-sub-gap {\n  grid-column: span 2;\n}\n.wo-sub-prods {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n}\n.wo-sub-prods .wo-prodcard {\n  min-height: 26px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n\n/* ---------------- selection bar ---------------- */\n.wo-selectbar {\n  flex-shrink: 0;\n  background: #fff;\n  border-top: 1px solid #e2dcd0;\n  padding: 12px 28px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-wrap: wrap;\n  row-gap: 10px;\n  box-shadow: 0 -6px 18px rgba(40, 34, 22, 0.06);\n}\n.wo-selectbar-count {\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  background: #17150f;\n  color: var(--rf-brand-bright);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n.wo-selectbar-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #191714;\n}\n.wo-selectbar-note {\n  font-size: 11.5px;\n  color: #8b8477;\n}\n.wo-selectbar .rf-btn {\n  height: 36px;\n  border-radius: 9px;\n}\n.wo-build {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.wo-build:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.wo-build-hint {\n  font-size: 11px;\n  opacity: 0.75;\n  font-weight: 400;\n}\n.wo-pagepad {\n  height: 24px;\n  flex-shrink: 0;\n}\n\n/* ---------------- responsive: tablet ---------------- */\n@media (max-width: 1200px) {\n  .wo-runcard.is-new {\n    min-width: 220px;\n  }\n}\n@media (max-width: 1000px) {\n  /* claw back the 28px gutters so the order cards get the width instead */\n  .wo-filters,\n  .wo-selectbar {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n  .wo-runstrip {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n  .wo-tablewrap {\n    padding: 0 16px;\n  }\n}\n\n/* Order that came across from another business — its serial keeps that\n   business's prefix, so the row says where it came from. */\n.wo-from {\n  display: inline-block;\n  padding: 1px 8px;\n  border-radius: 10px;\n  background: #f3ece0;\n  border: 1px solid #e4d8c2;\n  color: var(--rf-brand-deep);\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  flex-shrink: 0;\n}\n\n/* ================= run mode: the type bubble ================= */\n/* The legacy list asked \"Casket Cover or Tribute?\" in a gold-capped bubble\n   with a tip on the row it came from — kept, on the brand tokens so it\n   follows each business's colour. */\n.wo-prompt-scrim {\n  position: fixed;\n  inset: 0;\n  z-index: 90;\n}\n.wo-prompt {\n  position: fixed;\n  z-index: 91;\n  width: 300px;\n  background: #fff;\n  border-radius: 7px;\n  box-shadow: 0 16px 40px rgba(40, 34, 22, 0.26);\n}\n.wo-prompt-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 11px 12px;\n  background: var(--rf-brand-lite);\n  color: #fff;\n  border-radius: 7px 7px 0 0;\n  position: relative;\n  z-index: 2;\n}\n.wo-prompt-head span {\n  flex-grow: 1;\n  text-align: center;\n  /* optical centring: the close button sits in the right-hand gutter */\n  padding-left: 26px;\n  font-size: 15.5px;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.wo-prompt-x {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  color: #fff;\n  font-size: 21px;\n  line-height: 0;\n  opacity: 0.85;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.wo-prompt-x:hover {\n  opacity: 1;\n}\n.wo-prompt-opts {\n  display: flex;\n  position: relative;\n  z-index: 2;\n}\n.wo-prompt-opts button {\n  width: 50%;\n  padding: 12px 10px;\n  border: none;\n  background: #fff;\n  font: 500 15px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n  cursor: pointer;\n}\n.wo-prompt-opts button:first-child {\n  border-radius: 0 0 0 7px;\n}\n.wo-prompt-opts button:last-child {\n  border-radius: 0 0 7px 0;\n  border-left: 1px solid #efe9dd;\n}\n.wo-prompt-opts button:hover {\n  background: var(--rf-brand-lite);\n  color: #fff;\n}\n/* the tip: a square turned on its corner, tucked behind the bubble so\n   only the half pointing at the row shows */\n.wo-prompt-tip {\n  position: absolute;\n  left: 50%;\n  bottom: -9px;\n  z-index: 0;\n  width: 18px;\n  height: 18px;\n  margin-left: -9px;\n  background: var(--rf-brand-lite);\n  transform: rotate(45deg);\n}\n.wo-prompt.is-below .wo-prompt-tip {\n  bottom: auto;\n  top: -9px;\n}\n\n/* ================= run mode: the \"can't add that\" notice ================= */\n.wo-alert-wrap {\n  position: fixed;\n  inset: 0;\n  z-index: 95;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n.wo-alert-scrim {\n  position: absolute;\n  inset: 0;\n  background: rgba(25, 23, 20, 0.34);\n}\n.wo-alert {\n  position: relative;\n  width: 380px;\n  max-width: 100%;\n  background: #fff;\n  border: 1px solid #ddd7cb;\n  border-radius: 14px;\n  box-shadow: 0 30px 80px rgba(40, 34, 22, 0.3);\n  padding: 20px 22px 18px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n}\n.wo-alert-title {\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 21px;\n  color: #191714;\n}\n.wo-alert-msg {\n  font-size: 13.5px;\n  line-height: 1.5;\n  color: #4a453c;\n  text-wrap: pretty;\n}\n.wo-alert .rf-btn {\n  align-self: flex-end;\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
